module.exports = __webpack_public_path__ + "static/media/voice01.035d65da.png";